import { Vector2 } from "peet-math";
import { SimpleAnim } from "./simple-anim-control";
const panim = require('peter-anim-js');

export class TicketFlashAnim extends SimpleAnim {
  public cssDummy: any;
  public style: any;
  public visible: boolean;
  public shown: boolean;
  public radius: number;
  public maxBGAlpha: number;
  public maxBorderAlpha: number;
  public bgAlpha: number;
  public borderAlpha: number;
  public position: Vector2;
  public anim: any;

  constructor(containerTag: JQuery<HTMLElement>) {
    super(containerTag);
    this.startAt = this.startAt.bind(this);
    this._renderCanvas = this._renderCanvas.bind(this);
    this.containerTag = containerTag;
    super(arguments[0], "ticketSearchFlash");

    this.radius = 50;
    this.bgAlpha = 0;
    this.borderAlpha = 0;
  }

  startAt(posOnPlan, renderCb, after) {
    this.position = posOnPlan;
    this.visible = true;
    
    const radiusEase = panim.getScaledEaseFunct(10, 70, panim.easeLinear);
    const bgAlphaEase = panim.getScaledEaseFunct(this.style.backgroundColorObj.rgba[3], 0, panim.easeLinear);
    const borderAlphaEase = panim.getScaledEaseFunct(this.style.borderColorObj.rgba[3], 0, panim.easeLinear);
    return this.anim = new panim.Anim(300, (t, delta) => {
      this.radius = radiusEase(t);
      this.bgAlpha = bgAlphaEase(t);
      this.borderAlpha = borderAlphaEase(t);
      return renderCb();
    }).then(() => {
      this.stop(renderCb);
      if (after != null) {
        return after();
      }
    });
  }
  
  _renderCanvas(viewport, c) {
    const posOnView = viewport.pointPToV(this.position);
    c.beginPath();
    c.arc(posOnView.x, posOnView.y, this.radius, 0, 2 * Math.PI, false);

    const bgColor = this.style.backgroundColorObj;
    c.fillStyle = `rgba(${bgColor.rgba[0]}, ${bgColor.rgba[1]}, ${bgColor.rgba[2]}, ${this.bgAlpha})`;
    c.fill();

    const borderColor = this.style.borderColorObj;
    c.lineWidth = 10;
    c.strokeStyle = `rgba(${borderColor.rgba[0]}, ${borderColor.rgba[1]}, ${borderColor.rgba[2]}, ${this.borderAlpha})`;
    return c.stroke();
  }
}